import { render, staticRenderFns } from "./FareBreakdown.vue?vue&type=template&id=3c4b44f8&scoped=true&"
import script from "./FareBreakdown.vue?vue&type=script&lang=js&"
export * from "./FareBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./FareBreakdown.vue?vue&type=style&index=0&id=3c4b44f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b44f8",
  null
  
)

export default component.exports